/* istanbul ignore file */
import React from 'react'
import classnames from 'classnames/bind'
import Text from '../../elementals/text'
import styles from './styles.scss'

const cx = classnames.bind(styles)

export interface RadioButtonFieldType {
  label: string
  subLabel?: string
  image?: string
  children?: JSX.Element
  value: string | number
  checked?: boolean
  onChange: (event: Event | null, data: { type: string; value: any }) => void
  className: string[]
  disabled: boolean
  secondary?: boolean
  elmId: string
}

const RadioButtonField = ({
  label,
  subLabel,
  image,
  children,
  value,
  onChange,
  checked,
  disabled,
  className = [],
  secondary = false,
  elmId,
}: RadioButtonFieldType) => {
  const targetImg = typeof image === 'string' ? `url(${image})` : image

  const onClick = () => {
    if (!disabled) {
      onChange(null, { type: 'radio', value })
    }
  }

  return (
    <div
      className={cx(
        'radio-button-field',
        { selected: checked && !disabled, disabled, secondary },
        ...className
      )}
      onClick={onClick}
      data-elm-id={elmId}
    >
      <div className={cx('radio-button-field-content')}>
        <div
          className={cx('radio-button-field-labels', {
            'includes-image': Boolean(image),
          })}
        >
          <div>
            <Text size='huge' color='black'>
              {label}
            </Text>
          </div>
          {subLabel && (
            <div>
              <Text size='large' color='gray'>
                {subLabel}
              </Text>
            </div>
          )}
          {children && (
            <div className={cx('child-component')}>
              {React.cloneElement(children, { disabled: !checked || disabled })}
            </div>
          )}
        </div>
        {image && (
          <div className={cx('radio-button-image-container')}>
            <div
              style={{ backgroundImage: targetImg }}
              className={cx('radio-button-image')}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default RadioButtonField
